import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withProps, compose, withHandlers } from 'recompose'

import { Gates } from 'utils/Access'
import { CtaTypes, CtaViewConfig, PlaybookReportType } from 'app/modules/playbook/constants'

import * as PlaybookActions from 'app/modules/playbook/actions'
import * as PlaybookSelectors from 'app/modules/playbook/selectors'
import * as UserSelectors from 'app/modules/user/selectors'
import * as PlaybookModels from 'app/modules/playbook/models'
import { makeHasGate, isOnFreePlan } from 'app/modules/gates/selectors'

import MessageCta from './component'

const gatedMeetingCta = {
  label: (
    <div className="disabled">
      Schedule a Meeting <span className="upgrade-cta">Upgrade to Enterprise</span>
    </div>
  ),
  value: -1,
}

const disabledMeetingCta = {
  label: (
    <div className="disabled">Schedule a Meeting (only non-bot users can book meetings for themselves)</div>
  ),
  disabled: true,
  value: -1,
}

const unGatedMeetingCta = {
  label: 'Schedule a Meeting',
  value: CtaTypes.MEETING,
}

const noCta = {
  label: 'No CTA',
  value: CtaTypes.NONE,
}

const CtaTypeOptions = [
  {
    label: 'Start a Conversation',
    value: CtaTypes.CHAT,
  },
  {
    label: 'Link to a URL',
    value: CtaTypes.URL,
  },
]

const mapStateToProps = state => ({
  welcomeMessage: PlaybookSelectors.welcomeMessage(state),
  firstGoal: PlaybookSelectors.firstGoal(state),
  isOnFreePlan: isOnFreePlan(state),
  hasMeetingCta: makeHasGate('has_meeting_cta')(state),
  hasEnterpriseAccount: makeHasGate(Gates.PLAYBOOKS)(state),
  botUser: UserSelectors.botUser(state),
  reportType: PlaybookSelectors.reportType(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      setCtaType: PlaybookActions.setCtaType,
      setCtaLink: PlaybookActions.setCtaLink,
      setCtaCopy: PlaybookActions.setCtaCopy,
      saveGoalRoutingOption: PlaybookActions.saveGoalRoutingOption,
    },
    dispatch
  ),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps(props => {
    const meetingCtaIsDisabled = props.botUser &&
      props.botUser.id === props.welcomeMessage.authorId &&
      props.reportType !== PlaybookReportType.ABM
    const meetingCta = props.hasEnterpriseAccount || props.hasMeetingCta ?
      (meetingCtaIsDisabled ? disabledMeetingCta : unGatedMeetingCta)
      :
      gatedMeetingCta
    return {
      CtaTypeOptions: [...CtaTypeOptions, meetingCta, noCta],
      cta: PlaybookModels.Cta(props.welcomeMessage.cta),
    }
  }),
  withProps(props => ({
    showCtaCopy: CtaViewConfig[props.cta.type || CtaTypes.NONE].showCopy,
    showCtaUrl: CtaViewConfig[props.cta.type || CtaTypes.NONE].showUrl,
    ctaType: props.cta.type,
    CtaViewConfig: CtaViewConfig,
  })),
  withHandlers({
    onAuthorChange: props => ({ value }) => {
      props.actions.setAuthorId(value)
    },
    onCtaChange: ({ actions, firstGoal, isOnFreePlan, reportType }) => e => {
      if (!e) {return}
      if (isOnFreePlan && e.value !== CtaTypes.CHAT) {
        actions.setCtaType(CtaTypes.CHAT)
        return
      }
      if (e.value === -1) {
        window.location.hash = 'enterprise-upgrade'
      } else {
        if (e.value === CtaTypes.MEETING && reportType !== PlaybookReportType.ABM) {
          actions.saveGoalRoutingOption({
            goalRoutingOption: PlaybookModels.RoutingOption(),
            goalId: firstGoal.id
          })
        }
        actions.setCtaType(e.value)
      }
    },
    onCtaCopyChange: props => e => {
      props.actions.setCtaCopy(e.target.value)
    },
    onCtaLinkChange: props => e => {
      props.actions.setCtaLink(e.target.value)
    },
  })
)(MessageCta)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/MessageCta/index.js